















  import {Component, Vue} from 'vue-property-decorator';
  import LoadingAnimation from '@/app/common/component/LoadingAnimation.vue';

  @Component({
    name: 'App',
components: {
      LoadingAnimation,
    },
  })
  export default class App extends Vue {
    get hasLicense(): boolean {
      return !this.$store.getters.license && !this.$store.getters.loading;
    }

    get loading(): boolean {
      return this.$store.getters.loading
    }

    get noLicenseInfo() {
      return this.$t('NO_LICENSE_TEMPLATE_INFO')
    }
  }
